module.exports = __webpack_public_path__ + "static/media/svar.3cc6c731.mp3";